// =============================================================================
// FILE PATH: src/modules/pms/components/UserBPMappingForm.js
// =============================================================================

import React, { useEffect, useState } from "react";
import {
  getEmployees,
  getAssignableBusinessPartners,
  saveUserBPMapping
} from "../services/userBpMappingService";

export default function UserBPMappingForm({ open, onClose }) {

  const [employees, setEmployees] = useState([]);
  const [bpList, setBpList] = useState([]);

  const [employeeId, setEmployeeId] = useState("");
  const [bpId, setBpId] = useState("");

  // LOAD DATA
  useEffect(() => {
    if (open) {

      getEmployees()
        .then(res => {
          setEmployees(res.data.data || []);
        })
        .catch(err => console.error(err));

      getAssignableBusinessPartners()
        .then(res => {
          setBpList(res.data.data || []);
        })
        .catch(err => console.error(err));

    }
  }, [open]);

  // 🔥 SAVE FUNCTION ADDED
  const handleSave = () => {

    if (!employeeId || !bpId) {
      alert("Please select both Employee and Business Partner");
      return;
    }

    const payload = {
      employee_id: parseInt(employeeId),
      business_partner_id: parseInt(bpId)
    };

    saveUserBPMapping(payload)
      .then(() => {
        alert("Mapping saved successfully");
        onClose();
      })
      .catch(err => {
        console.error(err);
        alert("Error saving mapping");
      });
  };

  if (!open) return null;

  return (
    <div style={styles.overlay}>

      <div style={styles.modal}>

        <h3 style={styles.title}>Map Employee to Business Partner</h3>

        {/* FORM */}
        <div style={styles.formGroup}>
          <label>Employee</label>

          {/* 🔥 CONNECTED TO STATE */}
          <select
            style={styles.input}
            value={employeeId}
            onChange={(e) => setEmployeeId(e.target.value)}
          >
            <option value="">-- Select Employee --</option>

            {employees.map(emp => (
              <option key={emp.id} value={emp.id}>
                {emp.username}
              </option>
            ))}
          </select>
        </div>

        <div style={styles.formGroup}>
          <label>Business Partner</label>

          {/* 🔥 CONNECTED TO STATE */}
          <select
            style={styles.input}
            value={bpId}
            onChange={(e) => setBpId(e.target.value)}
          >
            <option value="">-- Select Business Partner --</option>

            {bpList.map(bp => (
              <option key={bp.id} value={bp.id}>
                {bp.name} ({bp.role})
              </option>
            ))}
          </select>
        </div>

        {/* ACTIONS */}
        <div style={styles.actions}>
          <button style={styles.cancelBtn} onClick={onClose}>
            Cancel
          </button>

          {/* 🔥 SAVE CONNECTED */}
          <button style={styles.saveBtn} onClick={handleSave}>
            Save
          </button>
        </div>

      </div>

    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0.4)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000
  },

  modal: {
    width: 400,
    background: "#fff",
    padding: 20,
    borderRadius: 6
  },

  title: {
    marginBottom: 15
  },

  formGroup: {
    marginBottom: 15,
    display: "flex",
    flexDirection: "column"
  },

  input: {
    padding: 8,
    borderRadius: 4,
    border: "1px solid #ccc"
  },

  actions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: 10
  },

  cancelBtn: {
    padding: "8px 12px",
    border: "1px solid #ccc",
    background: "#fff",
    cursor: "pointer"
  },

  saveBtn: {
    padding: "8px 12px",
    background: "#2563eb",
    color: "#fff",
    border: "none",
    cursor: "pointer"
  }
};